"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "itemLabelFilter", {
  enumerable: true,
  get: function get() {
    return _MultiSelect.itemLabelFilter;
  }
});
var _autocomplete = require("@clayui/autocomplete");
var _MultiSelect = require("./MultiSelect");
/**
 * SPDX-FileCopyrightText: © 2025 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = exports.default = Object.assign(_MultiSelect.MultiSelect, {
  Item: _autocomplete.Item
});